<div class="flex gap-2">
  <p-checkbox
    [id]="id"
    [binary]="true" 
    [tabindex]="getTabIndex()"
    [formControl]="getFormControl()"
    [value]="getValue()"
  />
  <eo-form-label
    *ngIf="isVisible()"
    [formId]="id"
    [label]="getLabel()"
    [required]="isRequired()"
  />
</div>
